import React from 'react';
import { NextPage } from 'next';
import {
  EnergyManagement,
  GridOptimization,
  LEDServices,
  SolarEnergy,
  FindAll,
  ListServices,
  GetInTouch,
} from 'templates/us-energy-solutions';
import { HeroProductSection } from 'components/structures/general';
import { Flower } from 'svgs';
import { usEnergySolutions } from 'images/us-energy-solutions';
import { SEO } from 'templates/layout';

const UsEnergySolutions: NextPage = () => {
  return (
    <>
      <SEO
        title="US Energy Solutions"
        description="Learn more about the company that helps save on energy, find cheaper gas & electricity, upgrade lighting and provide a one-stop-shop for EV Charging."
      />
      <HeroProductSection
        svgIcon={<Flower />}
        title="US Energy Solutions"
        description="US Energy Solutions is a full-range energy-consulting company. It means it’s offering an array of super-convenient energy procurement solutions. The primary goal is to demystify the energy industry and make it less… complicated for energy consumers."
        image={{ image: usEnergySolutions, maxWidth: 954 }}
        hypertextReference={'https://usenergysolutions.us/'}
        gridLgContent={8}
        gridLgImage={10}
      />
      <ListServices />
      <LEDServices />
      <GridOptimization />
      <SolarEnergy />
      <EnergyManagement />
      <FindAll />
      <GetInTouch />
    </>
  );
};

export default UsEnergySolutions;
